"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _theme = require("../../theme");

var _default = {
  MuiMenuItem: {
    root: {
      "&.Mui-selected": {
        "&:hover, &:focus-visible": {
          backgroundColor: _theme.palette.brand.grey.lightGrey
        },
        backgroundColor: _theme.palette.brand.grey.lightGrey,
        fontWeight: "bold"
      },
      "&:focus-visible": {
        backgroundColor: "rgba(0, 0, 0, 0.04)"
      },
      color: _theme.palette.brand.grey.charcoal,
      fontSize: "0.75rem",
      paddingBottom: _theme.spacing[2],
      paddingTop: _theme.spacing[2],
      whiteSpace: "normal"
    }
  }
};
exports.default = _default;